// Import necessary modules
import {
  Input,
  MultiSearchForm,
  useDebouncedSearch,
  useRef,
  useState,
  useEffect,
} from "@";
import { searchValues } from "../utils/options";
import { getAllEnums } from "../utils/api";
import { enumsOptions } from "../utils/helpers";

// Component for rendering the multi-search form
const MultiSearch = ({ onSubmit, search, updateSearch, dataLength }) => {
  useDebouncedSearch(onSubmit, search.values, searchValues);
  const [enums, setEnums] = useState([]);
  const hasFetchedData = useRef(false);

  // Function to fetch Enums
  const fetchEnums = async () => {
    const { data } = await getAllEnums();
    setEnums(data);
  };

  useEffect(() => {
    if (dataLength > 0 && !hasFetchedData.current) {
      fetchEnums();
      hasFetchedData.current = true;
    }
  }, [dataLength]);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-6"
      reset={() => updateSearch({ values: searchValues })}
    >
      {/* Input for searching by title */}
      <Input
        change={(e) => handleInputChange("title", e.target.value)}
        value={search.values.title}
        label="كلمة البحث"
        star
      />

      {/* Input for searching by message status */}
      <Input
        star
        type="select"
        label="حالة الرسالة"
        value={search.values.messageStatus}
        list={enumsOptions(enums?.MessageStatus)}
        change={(e) => handleInputChange("messageStatus", e.target.value)}
      />

      {/* Input for searching by message type */}
      <Input
        star
        label="التصنيف"
        type="select"
        value={search.values.messageType}
        list={enumsOptions(enums?.MessageType)}
        change={(e) => handleInputChange("messageType", e.target.value)}
      />

      {/* Input for searching by date range */}
      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        style="lg:col-span-2"
        valueB={search.values.toDate}
        valueA={search.values.fromDate}
        changeA={(e) => handleInputChange("fromDate", e)}
        changeB={(e) => handleInputChange("toDate", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
